import { Project } from 'configs'
import { GetAllResponse, ListParams } from '@type/common'
import { UserInvite, UserListResponse } from '@type/schemas/UserSchema'
import { getAxios } from './api'

// API Request for user invitation
export async function reqUserInvite({ email, role }: { email: string; role: string }) {
  const { data } = await getAxios().post('/user-invite', {
    email,
    role,
    projectType: Project.END_THE_RIG,
  })
  return data
}

// API Request for email of user invitation
export async function getUserInviteEmail(id: string) {
  const { data } = await getAxios().get(`/user-invite/email/${id}`)
  return data
}

// API Request for user invitation
export async function reqUserInviteRegistration(values: {
  id: string
  username: string
  email: string
  password: string
}) {
  const { id, ...userData } = values
  const { data } = await getAxios().post('/user-invite/register', {
    id,
    user: userData,
  })
  return data
}

export async function fetchAllUserInvites(params: ListParams) {
  const { data } = await getAxios().get<GetAllResponse<UserInvite>>(`user-invite/list`, {
    params,
  })
  return data
}

export async function fetchAllUsers({
  limit,
  page,
  search,
  sortBy,
  sortOrder,
}: {
  page?: number
  limit?: number
  search?: string
  sortBy?: string
  sortOrder?: string
}) {
  let sorting
  if (sortBy && sortOrder) {
    sorting = {
      column: sortBy,
      arrange: sortOrder,
    }
  }
  const { data } = await getAxios().get<UserListResponse>(`/user/list`, {
    params: {
      pagination: {
        page,
        limit,
      },
      sorting,
      search,
    },
  })
  return data
}
